import { ArrowLeft, ArrowRight } from 'lucide-react';

import IconButton from '@/features/common/components/IconButton';
import { cn } from '@/lib/utils';

type DotNavigationProps = {
  currentStep: number;
  totalSteps: number;
  className?: string;
  onStepChange: (step: number) => void;
};

const DotNavigation = ({
  currentStep,
  totalSteps,
  onStepChange,
  className,
}: DotNavigationProps) => {
  return (
    <div className={cn('flex gap-10 items-center justify-between', className)}>
      <IconButton
        icon={<ArrowLeft strokeWidth={2.3} className="min-h-6 min-w-6" />}
        onClick={() => currentStep > 0 && onStepChange(currentStep - 1)}
        className={cn(currentStep === 0 && 'opacity-0')}
      />
      <div className="flex gap-3 items-center">
        {Array.from({ length: totalSteps }).map((_, index) => (
          <div
            key={index}
            className={cn(
              'h-4 w-4 rounded-full bg-gray-300 cursor-pointer',
              currentStep === index && 'bg-primary',
            )}
            onClick={() => onStepChange(index)}
          />
        ))}
      </div>
      <IconButton
        icon={<ArrowRight strokeWidth={2.3} className="min-h-6 min-w-6" />}
        onClick={() => currentStep < totalSteps - 1 && onStepChange(currentStep + 1)}
        className={cn(currentStep === totalSteps - 1 && 'opacity-0')}
      />
    </div>
  );
};

export default DotNavigation;
